/**
 * /admin/document-coverage — firm-wide missing-documents dashboard (route shell).
 * Screen impl in `./document-coverage-screen.tsx`, lazy-loaded (P2-3, spec §17).
 */

import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router';

export const Route = createFileRoute('/admin/document-coverage')({
  component: lazyRouteComponent(
    () => import('./document-coverage-screen'),
    'DocumentCoverageBoard',
  ),
});
